import {  ProductFilter } from '../types/products';
import api from '../apis/constants';

// Lấy danh sách sản phẩm
const getProducts = async (filter: ProductFilter) => {
    try {
        const response = await api.get('/products/admin/all', { params: filter });
        return {
            products: response.data.products,
            total: response.data.pagination.total,
            page: response.data.pagination.page,
            limit: response.data.pagination.limit,
            totalPages: Math.ceil(response.data.pagination.total / response.data.pagination.limit)
        };
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
};

// Lấy thông tin chi tiết sản phẩm
const getProductById = async (id: string) => {
    try {
        const response = await api.get(`/products/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching product:', error);
        throw error;
    }
};

// Tạo sản phẩm mới
const createProduct = async (data: any) => {
    try {
        return await api.post('/products', data);
    } catch (error) {
        console.error('Error creating product:', error);
        throw error;
    }
};

// Cập nhật sản phẩm
const updateProduct = async (id: string, data: any) => {
    try {
        const response = await api.patch(`/products/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating product:', error);
        throw error;
    }
};

// Xóa sản phẩm
const deleteProduct = async (id: string) => {
    try {
        const response = await api.delete(`/products/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting product:', error);
        throw error;
    }
};

export interface ProductSelector {
  _id: string;
  name: string;
  materialType: string;
  images: string[];
}

export interface ProductsSelectorResponse {
  success: boolean;
  data: ProductSelector[];
}

const getProductSelectors = async (): Promise<ProductsSelectorResponse> => {
    try {
        const response = await api.get('/products/selectors');
        return response.data;
    } catch (error) {
        console.error('Error fetching product selectors:', error);
        throw error;
    }
}


const productService = {
    getProducts,
    getProductById,
    createProduct,
    updateProduct,
    deleteProduct,
    getProductSelectors,
};

export default productService;
